// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"c0ae2282","774":"c39eb7c0"}[chunkId] + ".chunk.js";
};